import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";

import {
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import WithoutFtdCard from "./WithoutFtdCard";

const WithoutFtdItem = ({
  sortedData = [],
}: {
  sortedData?: Record<string, any>[];
}) => {
  if (!sortedData?.length) {
    return (
      <Box sx={{ mt: spacing.Spacing.xl.$value, textAlign: "center" }}>
        <Typography sx={{ fontSize: typography.Size.Text.sm.$value }}>
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
      <Stack spacing={2}>
        {sortedData.map((item, index) => (
          <WithoutFtdCard
            key={`${item.brand_id ?? "row"}-${index}`}
            brand_display_name={item.brand_display_name}
            brand_id={item.brand_id}
            clicks={item.clicks}
            brand_action_date={item.brand_action_date}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default WithoutFtdItem;
